import { render, staticRenderFns } from "./ProductFiltersSidebar.vue?vue&type=template&id=eaf6d2a2&scoped=true&"
import script from "./ProductFiltersSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductFiltersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductFiltersSidebar.vue?vue&type=style&index=0&id=eaf6d2a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf6d2a2",
  null
  
)

export default component.exports